import * as React from 'react';
import { IsologoProps } from '..';

export const SpotifyIsologo: React.FC<IsologoProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.5 8"
      width={12.5}
      height={8}
      {...props}
    >
      <path
        fill={props.fill}
        d="M10.09,7.75c-.04.06-.09.11-.14.15-.06.04-.12.07-.19.09-.07.02-.14.02-.21,0-.07-.01-.14-.03-.2-.07-2.06-1.22-4.66-1.49-7.71-.82-.07.02-.15.02-.22.01-.07,0-.14-.03-.21-.07-.06-.04-.12-.09-.16-.14-.04-.06-.07-.12-.09-.19-.02-.07-.02-.14,0-.21.01-.07.04-.14.08-.2.04-.06.09-.11.15-.15.06-.04.13-.07.2-.08,3.34-.74,6.21-.42,8.53.94.06.04.12.08.16.14.04.06.07.12.09.19s.02.14,0,.21c-.01.07-.04.13-.07.19h0ZM11.17,5.44c-.05.07-.11.14-.18.19-.07.05-.16.09-.24.11-.09.02-.18.02-.27,0-.09-.01-.17-.04-.25-.09-2.36-1.4-5.96-1.81-8.75-.99-.09.03-.18.03-.27.03-.09,0-.18-.03-.26-.07-.16-.08-.28-.22-.33-.39-.05-.17-.03-.35.05-.5s.23-.27.41-.32c3.19-.93,7.15-.48,9.86,1.13.16.09.27.24.31.41.04.17.01.35-.08.5h0ZM11.26,3.03c-2.83-1.62-7.5-1.77-10.2-.98-.21.06-.43.04-.63-.06-.19-.1-.34-.27-.4-.47-.06-.2-.04-.42.06-.6.1-.19.28-.32.49-.38C3.68-.38,8.84-.2,12.1,1.67c.09.05.17.12.24.21.06.08.11.18.14.28.03.1.03.21.02.31-.02.1-.05.2-.11.29-.06.09-.13.17-.21.23-.09.06-.18.11-.29.13-.1.03-.21.03-.32.02-.11-.01-.21-.05-.3-.1h0Z"
      />
    </svg>
  );
};

export default SpotifyIsologo;
